import * as UI from '@brewlogix/blx-ui'

import CurrentDayStatus from '../Details/CurrentDayStatus'
import { Location } from 'src/types/schema/graphql'
import React from 'react'
import classNames from 'classnames'
import { parseEnumLabel, parsePatronOptionToSlug } from 'src/util/helpers'
import { useLocationSlugStore } from '../../state/useLocationSlugStore'
import { useRouter } from 'next/router'
import * as CC from '@chakra-ui/react'
import CardHeader from 'src/components/cards/CardHeader'
import CardContent from 'src/components/cards/CardContent'

interface IAlsoLikeCardProps {
    location: Location
    distance: number
}

const AlsoLikeCard: React.FC<IAlsoLikeCardProps> = ({ location, distance }: IAlsoLikeCardProps) => {
    const router = useRouter()
    const { resetState, getLocations } = useLocationSlugStore()
    const handleCardClick = () => {
        router.push({
            pathname: '/brewer/[brewerSlug]/locations/[locationSlug]',
            query: { brewerSlug: location?.brand?.slug, locationSlug: location?.slug },
        })
        resetState()
        getLocations(location)
    }
    return (
        <>
            <CC.Card
                className='card card--default card--location h-fit w-full cursor-pointer p-0'
                mb='4'
                onClick={handleCardClick}
            >
                <CC.CardBody
                    w='100%'
                    className='duration-200 ease-in-out hover:border-transparent hover:bg-gray-50'
                    p='4'
                >
                    {location?.assets?.length > 0 &&
                        process.env.NEXT_PUBLIC_SHOW_LOCATION_IMAGES && (
                            <UI.Media
                                asset={location.assets[0]}
                                customClasses={'w-full h-full mb-4 rounded-md'}
                                width={350}
                                height={200}
                                alt={`Logo for ${location?.title}`}
                            />
                        )}
                    <CardHeader location={location} showRouteAction={false} distance={distance} />
                    <CardContent location={location} />
                </CC.CardBody>
            </CC.Card>
        </>
    )
}

export default AlsoLikeCard
